import { render, staticRenderFns } from "./backPassword.vue?vue&type=template&id=33ea0ada&"
import script from "./backPassword.vue?vue&type=script&lang=js&"
export * from "./backPassword.vue?vue&type=script&lang=js&"
import style0 from "./backPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports